<div class="basic"
    tabindex="-1"
    role="dialog"
    aria-hidden="true">
    <div class="modal-dialog"
        role="document"
        [ngClass]="dialogClass">
        <div class="modal-content">
            <ng-content select=".app-modal-header"></ng-content>

            <div class="modal-body">
                <ng-content select=".app-modal-body"></ng-content>
            </div>

            <ng-content select=".app-modal-footer"></ng-content>
        </div>
    </div>
</div>
